import Service from '@/services/modules/profileCommissions.service';

const get = async({ commit }, _object) => {
    const response = Service.get(_object.profile_id, _object.administrator_id);

    response.then(function (_response) {
        commit('set', _response);
    });

    return response;
};

const set = async({ commit }, _object) => {
    const response = Service.set(_object.profile_id, _object.administrator_id, _object.form);
    
    return response;
};

export default {
    get,
    set
};